

const debug = false


export { debug } 